import messages from "./messages.i18n";
export const buildReportTypePrices = (plans) => {
    var _a;
    const prices = {};
    for (const plan of plans !== null && plans !== void 0 ? plans : []) {
        if (plan.tier !== "basic" && plan.tier !== "premium")
            continue;
        const entry = (_a = prices[plan.tier]) !== null && _a !== void 0 ? _a : {};
        if (plan.interval === "monthly")
            entry.monthly = plan.unitAmount / 100;
        else
            entry.annualPerMonth = plan.unitAmount / 100 / 12;
        prices[plan.tier] = entry;
    }
    return prices;
};
const money = (value) => `$${value.toLocaleString("en-US", { maximumFractionDigits: 2 })}`;
export const getReportTypesText = (intl, billingPeriod = "annually", prices, options) => {
    var _a, _b, _c, _d;
    const basicStripePrice = billingPeriod === "monthly" ? (_a = prices === null || prices === void 0 ? void 0 : prices.basic) === null || _a === void 0 ? void 0 : _a.monthly : (_b = prices === null || prices === void 0 ? void 0 : prices.basic) === null || _b === void 0 ? void 0 : _b.annualPerMonth;
    const premiumStripePrice = billingPeriod === "monthly" ? (_c = prices === null || prices === void 0 ? void 0 : prices.premium) === null || _c === void 0 ? void 0 : _c.monthly : (_d = prices === null || prices === void 0 ? void 0 : prices.premium) === null || _d === void 0 ? void 0 : _d.annualPerMonth;
    const basicMonthlyPromo = billingPeriod === "monthly" && Boolean(options === null || options === void 0 ? void 0 : options.basicFirstReportFreePromo);
    return [
        {
            id: "basic",
            title: intl.formatMessage(messages.basicPlanTitle),
            subtitle: intl.formatMessage(messages.basicPlanSubtitleGeminiMonthlyReports),
            priceValue: basicMonthlyPromo
                ? intl.formatMessage(messages.basicPlanPriceValueFreeAmount)
                : basicStripePrice != null
                    ? money(basicStripePrice)
                    : money(0),
            priceInlineLabel: basicMonthlyPromo
                ? intl.formatMessage(messages.basicPlanPriceInlineFirstTwoMonthlyReportsFree)
                : intl.formatMessage(messages.basicPlanPriceInlinePerReportPerMonth),
            priceSubLabel: basicMonthlyPromo
                ? intl.formatMessage(messages.basicPlanPriceSubLabelThenTwentyFivePerReportMonthly)
                : billingPeriod === "monthly"
                    ? intl.formatMessage(messages.basicPlanPriceSubLabelBilledMonthly)
                    : intl.formatMessage(messages.basicPlanPriceSubLabelBilledAnnually),
            buttonLabel: intl.formatMessage(messages.basicPlanPrimaryActionGetBasicReports),
            featuresTitle: intl.formatMessage(messages.basicPlanFeaturesSectionTitle),
            features: [
                intl.formatMessage(messages.basicPlanFeatureFirstReportFreeForTwoMonths),
                intl.formatMessage(messages.basicPlanFeatureGeminiOnlyVisibilityTracking),
                intl.formatMessage(messages.basicPlanFeatureMonthlyReports),
                intl.formatMessage(messages.basicPlanFeatureCompetitorAnalysis),
            ],
            highlightedFeatureIndexes: [0],
            modelLabels: ["Gemini"],
            billingOptions: {
                annuallyLabel: intl.formatMessage(messages.basicPlanBillingOptionAnnually),
                discountLabel: intl.formatMessage(messages.basicPlanBillingOptionDiscountFifteenPercentOff),
                monthlyLabel: intl.formatMessage(messages.basicPlanBillingOptionMonthly),
            },
        },
        {
            id: "premium",
            title: intl.formatMessage(messages.premiumPlanTitle),
            subtitle: intl.formatMessage(messages.premiumPlanSubtitleAllModelsMonthlyReportsAndCustomTopics),
            priceValue: premiumStripePrice != null ? money(premiumStripePrice) : money(0),
            priceInlineLabel: intl.formatMessage(messages.premiumPlanPriceInlinePerReportPerMonth),
            priceSubLabel: billingPeriod === "monthly"
                ? intl.formatMessage(messages.premiumPlanPriceSubLabelBilledMonthly)
                : intl.formatMessage(messages.premiumPlanPriceSubLabelBilledAnnually),
            buttonLabel: intl.formatMessage(messages.premiumPlanPrimaryActionGetPremiumReports),
            featuresTitle: intl.formatMessage(messages.premiumPlanFeaturesSectionTitle),
            features: [
                intl.formatMessage(messages.premiumPlanFeatureAllAiModels),
                intl.formatMessage(messages.premiumPlanFeatureRecommendationsForImprovement),
                intl.formatMessage(messages.premiumPlanFeatureCustomizableTopics),
                intl.formatMessage(messages.premiumPlanFeatureDetailedCompetitorAnalysis),
            ],
            highlightedFeatureIndexes: [0],
            modelLabels: ["Gemini", "ChatGPT", "Claude", "Perplexity"],
            recommendedLabel: intl.formatMessage(messages.premiumPlanRecommendedLabel),
            billingOptions: {
                annuallyLabel: intl.formatMessage(messages.premiumPlanBillingOptionAnnually),
                discountLabel: intl.formatMessage(messages.premiumPlanBillingOptionDiscountFifteenPercentOff),
                monthlyLabel: intl.formatMessage(messages.premiumPlanBillingOptionMonthly),
            },
            isPrimaryAction: true,
        },
        {
            id: "enterprise",
            title: intl.formatMessage(messages.enterprisePlanTitle),
            subtitle: intl.formatMessage(messages.enterprisePlanSubtitleLargeOrganizationRollout),
            priceValue: intl.formatMessage(messages.enterprisePlanPriceValueContactSales),
            priceSubLabel: intl.formatMessage(messages.enterprisePlanPriceSubLabelTailoredToPortfolioSize),
            buttonLabel: intl.formatMessage(messages.enterprisePlanPrimaryActionGetInTouch),
            featuresTitle: intl.formatMessage(messages.enterprisePlanFeaturesSectionTitleIncludesEverythingInPremiumPlus),
            features: [
                intl.formatMessage(messages.enterprisePlanFeatureCommunityLevelBilling),
                intl.formatMessage(messages.enterprisePlanFeatureWhiteGloveImplementation),
                intl.formatMessage(messages.enterprisePlanFeaturePayByInvoice),
                intl.formatMessage(messages.enterprisePlanFeatureCustomReportFrequency),
            ],
            highlightedFeatureIndexes: [0],
            modelLabels: ["Gemini", "ChatGPT", "Claude", "Perplexity"],
        },
    ];
};
